module.exports = __webpack_public_path__ + "Wlogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wlogo.png
// module id = 1881
// module chunks = 0